import { render } from "./djylResourceNew.vue?vue&type=template&id=e837fe38&scoped=true"
import script from "./djylResourceNew.vue?vue&type=script&lang=js"
export * from "./djylResourceNew.vue?vue&type=script&lang=js"

import "./djylResourceNew.vue?vue&type=style&index=0&id=e837fe38&lang=scss&scoped=true"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e837fe38"]])

export default __exports__